// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"cbe57c1e","487":"f38b24a0","707":"aad0e211"}[chunkId] + ".chunk.js";
};